export default "__VITE_ASSET__j6Y4HTg5__"